import { memo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { DOMAIN } from "consts/general";

const OnboardingAssistanceCta = () => (
    <Box
        sx={{
            display: 'grid',
            placeContent: 'center',
            textAlign: 'center'
        }}
    >
        <Box>
            <Typography
                variant='h6'
                gutterBottom
            >
                Need assistance?
            </Typography>
            <Typography
                variant='body1'
                gutterBottom
            >
                Don't let the onboarding slow you down.
                <br />
                We're ready to help.
            </Typography>
            <Box
                component='a'
                href={`//${DOMAIN}/contact`}
                sx={{
                    color: theme => theme.palette.common.black,
                    textDecoration: 'underline',
                    cursor: 'pointer'
                }}
            >
                Schedule a meeting with us
            </Box>
        </Box>
    </Box>
);

export default memo(OnboardingAssistanceCta);
